 
/* eslint-disable no-case-declarations */
 
import { Payload } from ".";
import { AppDispatch } from "../../configureStore";
import execute from "../http/execute";
import failure from "../http/failure";
import { get } from "../http/request";
import success from "../http/success";

 
export type StatusState = {
    loading: any;
    success: any;
    failure: any;
    successful?: string;
    error?: string;
    isMobile: boolean;
};

const initialState: StatusState = {
    loading: {},
    success: {},
    failure: {},
    isMobile: false,
};

export const ERROR_MESSAGE = 'status/ERROR_MESSAGE';
export const CLEAR_ERROR = 'status/CLEAR_ERROR';

export const SUCCESSFUL_MESSAGE = 'status/SUCCESSFUL_MESSAGE';
export const CLEAR_SUCCESSFUL = 'status/CLEAR_SUCCESSFUL';

export const SET_MOBILE = 'status/SET_MOBILE';

export const GET_HEALTHCHECK_REQUEST = 'prompts/GET_HEALTHCHECK_REQUEST';
export const GET_HEALTHCHECK_SUCCESS = 'prompts/GET_HEALTHCHECK_SUCCESS';
export const GET_HEALTHCHECK_FAILURE = 'prompts/GET_HEALTHCHECK_FAILURE';

const reducer = (state = initialState, { type: actionType, message, isMobile }: { type: string; message?: string; isMobile?: boolean; }) => {
    switch (actionType) {
        case SUCCESSFUL_MESSAGE:
            return {
                ...state,
                successful: message,
            };
        case CLEAR_SUCCESSFUL:
            return {
                ...state,
                successful: undefined,
            };
        case ERROR_MESSAGE:
            return {
                ...state,
                error: message,
            };
        case CLEAR_ERROR:
            return {
                ...state,
                error: undefined,
            };
        case SET_MOBILE:
            return {
                ...state,
                isMobile,
            };
        default:
            const matches = /(\w+)\/(\w+)_(REQUEST|SUCCESS|FAILURE)/.exec(actionType);

            if (!matches) return state;

            const [, reducerName, actionName, requestState] = matches;
            const namespace = `${reducerName}/${actionName}`;

            return {
                ...state,
                loading: {
                    ...state.loading,
                    [namespace]: requestState === 'REQUEST',
                },
                success: {
                    ...state.success,
                    [namespace]: requestState === 'SUCCESS',
                },
                failure: {
                    ...state.failure,
                    [namespace]: requestState === 'FAILURE',
                },
            };
    }
};

export const clearError = () => (dispatch: AppDispatch) => {
    dispatch({
        type: CLEAR_ERROR,
    });
};

export const clearSuccessful = () => (dispatch: AppDispatch) => {
    dispatch({
        type: CLEAR_SUCCESSFUL,
    });
};

export const healthcheck = (payload: Payload<void>) => (dispatch: AppDispatch) => {
    dispatch({
        type: GET_HEALTHCHECK_REQUEST,
    });

    execute(get, '/healthcheck', undefined, undefined, payload.overrideAuth)
        .then(success(dispatch, GET_HEALTHCHECK_SUCCESS, payload.input))
        .catch(failure(dispatch, GET_HEALTHCHECK_FAILURE, payload));
};

export default reducer;
